import React, { useMemo, useState, useEffect, useRef } from "react";
import cx from "clsx";
import {
  ConnectCapitalFinancingPromotion,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";
import { useCurrentAccountQuery } from "../../../../../api/queries/useAccountQuery";
import styles from "./StripeCapitalTile.module.scss";
import PoweredByStripeIcon from "../../../../../assets/Icons/PoweredByStripeIcon";

const StripeCapitalTile = ({ onEmptyWidgets }) => {
  const { data: account } = useCurrentAccountQuery();
  const isEnabled = account?.globalSettings?.featureFlag?.stripeCapital;
  const [isLoaded, setIsLoaded] = useState(false);
  const containerRef = useRef(null);

  const stripeConnectInstance = useMemo(() => {
    if (!isEnabled) return null;
    return loadConnectAndInitialize({
      publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
      fetchClientSecret: async () => {
        const res = await http.post(
          HTTP_ENDPOINTS.stripe.capitalAccountSession(),
        );
        return res?.data?.data?.client_secret;
      },
      appearance: {
        variables: {
          colorBackground: "#ffffff",
        },
      },
    });
  }, [isEnabled]);

  useEffect(() => {
    if (!containerRef.current || !isEnabled) return;

    const checkIframeLoaded = () => {
      const iframe = containerRef.current?.querySelector("iframe");
      if (iframe) {
        setIsLoaded(true);
      } else {
        setTimeout(checkIframeLoaded, 100);
      }
    };

    const timer = setTimeout(checkIframeLoaded, 500);
    return () => clearTimeout(timer);
  }, [isEnabled]);

  if (!isEnabled) {
    return null;
  }

  return (
    <div
      ref={containerRef}
      className={cx("col-md-6 m-b-15", onEmptyWidgets && "p-l-0 p-r-0")}
      style={{ display: isLoaded ? "block" : "none" }}
    >
      <div className={styles.container}>
        <div className="m-b-20 flex items-center gap-16 bold">
          AR Capital <PoweredByStripeIcon />
        </div>
        <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
          <ConnectCapitalFinancingPromotion layout="banner" />
        </ConnectComponentsProvider>
      </div>
    </div>
  );
};

export default StripeCapitalTile;
